<template>
    <button
        :id="props.id"
        @click.prevent="handleClick"
        class="d-flex align-items-center justify-content-center w-100 h-100"
        :class="props.classes"
        :disabled="props.disabled"
    >
        <div class="svg-slot">
            <slot name="svg" />
        </div>
        <span class="text-slot" :class="[!props.disabled ? props.textClass : 'text-primary-white']">
            <slot name="text">Placeholder</slot>
        </span>
    </button>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits, withDefaults } from 'vue'

interface Props {
    id?: string
    disabled?: boolean
    classes?: string[]
    textClass?: string
}
interface Emits {
    (e: 'buttonClick'): void
}

// props
const props = withDefaults(defineProps<Props>(), {
    classes: () => ['button-primary', 'bg-primary-blue'],
    textClass: 'text-primary-white',
})

// emit
const emit = defineEmits<Emits>()

// handlers
const handleClick = () => {
    if (props.disabled) return
    emit('buttonClick')
}
</script>

<style  scoped></style>
